import type { SearchSummary } from '@tunasong/models'
import { Dialog, DialogTitle, DialogContent} from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './search-select-dialog.module.css'
import { FullSearch } from './full-search.js'
import type { FullSearchProps } from './full-search.js'

// Dialog to select an entity from search results
interface SearchSelectDialogProps extends Pick<FullSearchProps, 'defaultFilter' | 'initialQuery'> {
  open: boolean
  onSelected(result: SearchSummary): void
  onCanceled(): void
}

export const SearchSelectDialog: FC<SearchSelectDialogProps> = props => {
  const { defaultFilter, initialQuery, open, onCanceled, onSelected } = props

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={'sm'}
      className={styles.dialog}
      onClose={onCanceled}
    >
      <DialogTitle onClose={onCanceled}>Select an entity</DialogTitle>
      <DialogContent>
        <FullSearch
          onOpen={e => {
            onSelected(e)
          }}
          defaultFilter={defaultFilter}
          initialQuery={initialQuery}
          onClose={onCanceled}
        />
      </DialogContent>
    </Dialog>
  )
}
